<template>
  <div class="extended-info">
    <h3>{{info.title}}</h3>
    <p><span class="extended-info__label">Материал для СМИ:</span> <a :href="info.smi_url">{{info.smi_url}}</a></p>
    <p><span class="extended-info__label">Подпрограмма:</span> <span v-for="(item, index) of info.subroutine" :key="item">{{info.subroutine.length > 1 && index !== 0 ? ', ' + item : item}}</span></p>
    <p><span class="extended-info__label">Региональный проект:</span> <span v-for="(item, index) of info.regin_project" :key="item">{{info.regin_project.length > 1 && index !== 0 ? ', ' + item : item}}</span></p>
    <p><span class="extended-info__label">Направления стратегии:</span> <span v-for="(item, index) of info.stategy" :key="item">{{info.stategy.length > 1 && index !== 0 ? ', ' + item : item}}</span></p>
    <p><span class="extended-info__label">Сфера:</span> <span v-for="(item, index) of info.sphere" :key="item">{{info.sphere.length > 1 && index !== 0 ? ', ' + item : item}}</span></p>
    <p><span class="extended-info__label">Каналы:</span> <span v-for="(item, index) of info.channels" :key="item">{{info.channels.length > 1 && index !== 0 ? ', ' + item : item}}</span></p>
    <p><span class="extended-info__label">Локация:</span> {{info.location}}</p>
    <p><span class="extended-info__label">Целевая Аудитория:</span> <span v-for="(item, index) of info.ca" :key="item">{{info.ca.length > 1 && index !== 0 ? ', ' + item : item}}</span></p>
    <p><span class="extended-info__label">Дата/время начала:</span> {{info.date_start}}</p>
    <p><span class="extended-info__label">Дата/время окончания:</span> {{info.date_finish}}</p>
    <p><span class="extended-info__label">Описание:</span> {{info.description}}</p>
    <p><span class="extended-info__label">Ссылка:</span> <a :href="info.url">{{info.url}}</a></p>
    <p><span class="extended-info__label">Ответственный:</span> {{info.responsible}}</p>
    <p><span class="extended-info__label">Соисполнители:</span> {{info.sub_responsible}}</p>
    <p><span class="extended-info__label">Участники:</span> {{info.members}}</p>
    <p><span class="extended-info__label">Дополнительные участники:</span> {{info.ext_members}}</p>
    <p><span class="extended-info__label">Автор:</span> {{info.author}}</p>
    <p><span class="extended-info__label">Дата создания:</span> {{info.created_date}}</p>
    <p><span class="extended-info__label">Дата изменения:</span> {{info.modify_date}}</p>
    <p><span class="extended-info__label">Хэштеги:</span> <span v-for="(item, index) of info.hashtag" :key="item">{{info.hashtag.length > 1 && index !== 0 ? ', ' + item : item}}</span></p>
    <p><span class="extended-info__label">Риски:</span> <span v-for="(item, index) of info.risks" :key="item">{{info.risks.length > 1 && index !== 0 ? ', ' + item : item}}</span></p>
  </div>
</template>

<script>
  // api
  import { getThreadExtendedApi } from '../../../../../api/feeds';

  // vuex
  import { mapGetters } from "vuex";

  export default {
    name: 'Extended',
    data() {
      return {
        info: {
          thread_id: 0,
          title: "string",
          smi_url: "http://example.com",
          subroutine: [
            "string"
          ],
          regin_project: [
            "string"
          ],
          stategy: [
            "string"
          ],
          sphere: [
            "string"
          ],
          channels: [
            "string"
          ],
          location: "string",
          ca: [
            "string"
          ],
          date_start: "2021-03-23 14:34:10",
          date_finish: "2021-03-23 14:34:10",
          description: "string",
          url: "http://example.com",
          responsible: "string",
          sub_responsible: "string",
          members: "string",
          ext_members: "string",
          author: "string",
          created_date: "2021-03-23 14:34:10",
          modify_date: "2021-03-23 14:34:10",
          hashtag: [
            "string"
          ],
          risks: [
            "string"
          ]
        },
      };
    },
    computed: {
      ...mapGetters([
        "users",
        "isAdmin",
      ]),
    },
    methods: {
      loadThreadExtended() {
        let params = {
          thread_id: parseInt(this.$route.params.threadId)
        };

        getThreadExtendedApi(params).then((resp) => {
          this.info = resp.data;
        });
      },
    },
    mounted() {
      this.loadThreadExtended();
    },
  };
</script>

<style>
  .extended-info {
    margin-bottom: 20px;
  }
  .extended-info p {
    padding: 12px 0;
    margin: 0;
    line-height: 1.4;
    border-top: 1px solid #dddddd;
  }
  .extended-info__label {
    font-weight: 500;
    margin-right: 10px;
  }
</style>